import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {Link, useNavigate, useParams} from "react-router-dom";
import {
    useGetDriverByIdQuery,
    useGetDriverQuery,
    useUpdateDriverByIdMutation
} from "../../../slices/rootApiSlices/driverApiSlice";
import {Breadcrumb, Button, Card, Form, Input, message, Select, Row, Col} from "antd";
import {CloseOutlined, SaveOutlined} from "@ant-design/icons";
import DeleteDriver from "./DeleteDriver";
import SearchVehicleWithID from "../../../components/SearchVehicleWithID";

const UpdateDriver = () => {


    const [form] = Form.useForm();
    const navigate = useNavigate();
    const {user} = useSelector(state => state.auth);
    const {refetch: refetchAllDrivers} = useGetDriverQuery(user?.token);
    const [name, setName] = useState("");
    const [surname, setSurName] = useState("");
    const [isActive, setIsActive] = useState(false);
    const [vehicle_id, setVehicleID] = useState("");


    const {id} = useParams();
    const {refetch: refetchDriverById, data, isLoading} = useGetDriverByIdQuery({
        token: user?.token,
        id: id
    });

    const [updateHandle, updateloading, error] = useUpdateDriverByIdMutation();

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                name: data?.data?.name,
                surname: data?.data?.surname,
                isActive: data?.data?.isActive,
                vehicle_id: data?.data?.vehicle_id
            });
        }
    }, [data, form]);

    const updateVehicle = async () => {
        const updatedDriver = {
            name: form.getFieldValue("name"),
            surname: form.getFieldValue("surname"),
            isActive: form.getFieldValue("isActive"),
            vehicle_id: form.getFieldValue("vehicle_id")
        }
        if (updatedDriver) {
            try {
                const res = await updateHandle({token: user?.token, data: updatedDriver, id}).unwrap();
                console.log(res)
                if (res) {
                    message.success('Güncelleme işlemi başarılı');
                    refetchDriverById();
                    refetchAllDrivers();
                    navigate('/settings/drivers')
                }
            } catch (e) {
                message.error(e?.data?.messageTR || 'Bir sorun ile karşılaşıldı.');
            }
        }
    }


    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        message.error(errorInfo, 3)
    };

    const {Option} = Select;

    return (<>
        <Breadcrumb>
            <Breadcrumb.Item>
                <Link to="/">Ana Ekran</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/settings/drivers">Sürücü Listesi</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Sürücü Düzenle</Breadcrumb.Item>
        </Breadcrumb>
        <Card
            style={{marginTop: 15}}
        >
            {isLoading && (<div>yükleniyor</div>)}
            {error && (<div> {error}</div>)}
            <Form
                name="update-vehicle"
                form={form}
                onFinish={updateVehicle}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Row gutter={16}>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="name"
                            label="İsim"
                            rules={[{
                                required: true, message: 'Lütfen isim giriniz !',
                            }]}
                            onChange={e => setName(e.target.value)}
                            value={name}
                        >
                            <Input placeholder="İsim"/>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="surname"
                            label="Soyisim"
                            rules={[{
                                required: true, message: 'Lütfen soyisim giriniz !',
                            }]}
                            onChange={e => setSurName(e.target.value)}
                            value={surname}
                        >
                            <Input/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            label="Araç Seçiniz"
                            name="vehicle_id"
                            onChange={() => setVehicleID()}
                            value={vehicle_id}
                        >
                            <SearchVehicleWithID onChange={() => setVehicleID()}/>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="isActive"
                            label="Durumu"
                            rules={[{
                                required: true, message: 'Lütfen durum giriniz !',
                            }]}
                            value={isActive}
                        >
                            <Select
                                onChange={(e) => setIsActive({...isActive})}
                                allowClear
                            >
                                <Option value={true}>Aktif</Option>
                                <Option value={false}>Pasif</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button style={{marginRight: 5}} loading={updateloading} type="primary" htmlType="submit"
                            icon={<SaveOutlined/>}>
                        Güncelle
                    </Button>
                    <Button href="/settings/drivers" type="primary" danger icon={<CloseOutlined/>}>
                        Vazgeç
                    </Button>
                    <DeleteDriver id={data?.data?.id}/>
                </Form.Item>
            </Form>
        </Card>
    </>);
};

export default UpdateDriver;
